<template>
    <div class="quickpay">
        <QuickpayPaymentOverviewSuccess
            v-if="currentView === 'success'"
            :data="data"
            @back="handleBack('overview')"
        />
        <QuickpayPaymentOverviewCard
            v-else-if="currentView === 'stripe'"
            :data="data"
            :hash="hash"
            @payment-success="setView('success')"
            @back="handleBack('overview')"
        />
        <template v-else>
            <div class="quickpay__container">
                <QuickpayPDFViewer
                    v-if="isLargeScreen"
                    :src="data.document.pdf_link"
                    :document="data.document"
                />
                <div class="quickpay__container-content">
                    <QuickpayEsignOverview
                        v-if="checkStep('esign_link')"
                        :data="data"
                        :hash="hash"
                    />
                    <QuickpayPaymentOverview
                        v-else-if="checkStep('payments')"
                        :data="data"
                        :hash="hash"
                        :deadlineId="deadlineId"
                        @show-stripe-payment="setView('stripe')"
                    />
                    <QuickpayOverview v-else :data="data" />
                </div>
            </div>
        </template>
        <FooterPoweredBySellsy v-if="hasQuickpayV2PoweredSellsyFeature" :fixedOnMobile="false" />
    </div>
</template>

<script>
import QuickpayPDFViewer from 'vcomponents/quickpay/QuickpayPDFViewer.vue';
import FooterPoweredBySellsy from 'vcomponents/common/FooterPoweredBySellsy.vue';
import QuickpayOverview from './QuickpayOverview.vue';
import QuickpayEsignOverview from 'vcomponents/quickpay/esign/QuickpayEsignOverview.vue';
import QuickpayPaymentOverview from 'vcomponents/quickpay/payment/QuickpayPaymentOverview.vue';
import QuickpayPaymentOverviewSuccess from 'vcomponents/quickpay/payment/QuickpayPaymentOverviewSuccess.vue';
import QuickpayPaymentOverviewCard from 'vcomponents/quickpay/payment/QuickpayPaymentOverviewCard.vue';
import Feature from 'Services/Feature';

export default {
    components: {
        QuickpayPDFViewer,
        FooterPoweredBySellsy,
        QuickpayOverview,
        QuickpayEsignOverview,
        QuickpayPaymentOverview,
        QuickpayPaymentOverviewSuccess,
        QuickpayPaymentOverviewCard,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
        hash: {
            type: String,
            required: true,
        },
        deadlineId: {
            type: Number,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            currentView: 'overview',
            isLargeScreen: window.innerWidth > 1023,
        };
    },
    computed: {
        hasQuickpayV2PoweredSellsyFeature() {
            return Feature.isEnabled('quickpay-v2-powered-by-sellsy');
        },
    },
    watch: {
        'data.step'() {
            this.updateViewFromStep();
        },
    },
    mounted() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        this.updateViewFromStep();
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        checkStep(step) {
            return this.data && this.data.step === step;
        },
        updateViewFromStep() {
            if (this.checkStep('payment_success')) {
                this.setView('success');
            }
        },
        setView(view) {
            this.currentView = view;
        },
        handleResize() {
            this.isLargeScreen = window.innerWidth > 1023;
        },
        handleBack(view) {
            if (window.location.pathname.includes('/success')) {
                const newPath = window.location.pathname.replace('/success', '');
                window.history.pushState(
                    {},
                    '',
                    newPath + window.location.search + window.location.hash,
                );
            }
            this.setView(view);
        },
    },
};
</script>

<style lang="scss">
.global:has(.quickpay) {
    min-width: 0 !important;
}
#contentDiv.has-sidebar-closed:has(.quickpay) {
    padding: 0 !important;
}
#contentDiv:has(.quickpay) .contentMargin {
    height: auto;
}
</style>

<style lang="scss" scoped>
.quickpay {
    @media (max-width: 1023px) {
        min-height: 100dvh;
        display: flex;
        flex-direction: column;
    }

    &__container {
        height: 100%;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        padding: var(--spacing-3);

        &-content {
            width: 100%;
            max-width: 400px;
        }

        @media (min-width: 1441px) {
            max-width: 1440px;
            margin: 0 auto;
        }

        @media (max-width: 1280px) {
            gap: var(--spacing-5);
        }

        @media (max-width: 1023px) {
            height: auto;
            align-items: normal;
            flex: 1;
        }
    }
}
</style>
